import type { CmtsRouteDefinition } from "./cmtsRouteTypes.js";
import { getCmtsMenuManifestEntries } from "./cmtsRouteLookup.js";

export type CmtsManifestMenuItem = {
  id: string;
  label: string;
  path: string;
  permission: string;
  description?: string | undefined;
};

export type CmtsManifestMenuGroup = {
  id: string;
  label: string;
  items: readonly CmtsManifestMenuItem[];
};

export function buildCmtsMenuFromManifest(routes: readonly CmtsRouteDefinition[] = getCmtsMenuManifestEntries()): readonly CmtsManifestMenuGroup[] {
  const groupMap = new Map<string, { id: string; label: string; items: CmtsManifestMenuItem[] }>();
  for (const route of routes.filter((item) => item.showInMenu).slice().sort((a, b) => (a.menuOrder ?? 9999) - (b.menuOrder ?? 9999))) {
    const id = route.menuGroupId ?? route.feature;
    const label = route.menuGroup ?? route.module;
    const group = groupMap.get(id) ?? { id, label, items: [] };
    group.items.push({
      id: route.id,
      label: route.title,
      path: route.menuPath ?? route.path,
      permission: route.permission,
      description: route.menuDescription,
    });
    groupMap.set(id, group);
  }
  return Array.from(groupMap.values());
}

export function buildFlatCmtsMenuFromManifest(routes: readonly CmtsRouteDefinition[] = getCmtsMenuManifestEntries()): readonly CmtsManifestMenuItem[] {
  return buildCmtsMenuFromManifest(routes).flatMap((group) => group.items);
}
